import React from "react";
import PropTypes from "prop-types";
import Video from "../../../common/Video";
import { ReactCompareSlider } from "react-compare-slider";
import { ModuleCopyBlock, ModuleSection } from "./Parts";

const CompareSlider = ({ isPlaying, portal, children, itemOne, itemTwo }) => {
  return (
    <ModuleSection>
      <div className={`${portal} unlocked-compare-slider w-full`}>
        {" "}
        <ReactCompareSlider
          position={75}
          style={{
            height: "100vh",
            width: "100%"
          }}
          onlyHandleDraggable={true}
          portrait={false}
          itemOne={
            <Video
              videoHeight={`w-full`}
              poster={itemOne}
              name={itemOne}
              autoplay={isPlaying}
            ></Video>
          }
          itemTwo={<Video poster={itemTwo} name={itemTwo} autoplay={isPlaying}></Video>}
        />
      </div>

      <ModuleCopyBlock className={`pointer-events-none`}>{children}</ModuleCopyBlock>
    </ModuleSection>
  );
};

CompareSlider.propTypes = {
  isPlaying: PropTypes.bool.isRequired
};

export default CompareSlider;
